import s from './LandingPage.module.css';
import { SvgLogo } from 'assets/svg';
import { Link } from 'react-router-dom';

function LandingPage() {
	return (
		<div className={s.root}>
			<div className={s.logo}>
				<SvgLogo />
			</div>
			<div className={s.title}>
				Welcome To
				<br />
				wake up
				<br /> Challenge
			</div>
			<div className={s.content}>
				Wake Up Challenge is built on the belief that challenges provide a
				powerful platform for personal growth, creativity, and connection.
			</div>
			<Link to={'/register_basic'} className="w-full sm:w-[200px]">
				<div className={s.continueButton}>Continue</div>
			</Link>
		</div>
	);
}

export default LandingPage;
